//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { I18n } from 'aws-amplify';
import {
  AmplifyTheme,
  Authenticator,
  ConfirmSignIn,
  RequireNewPassword,
} from 'aws-amplify-react';
import React from 'react';

import { Alert } from '@components/atoms/alert/Alert';

import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import styled from 'styled-components';
import ForgotPassword from './ForgotPassword';
import SignIn from './SignIn';
import { Toast } from './Toast';

import socialCommerceLogo from '@images/social-commerce-full.svg';
import vibeLogo from '@images/vibe-logo.svg';

const TOAST_FADE_TIME = 5000;

class CuralateAuthenticator extends Authenticator {
  constructor(props) {
    super(props);
  }

  // This render method was built by stripping down and customizing the code from aws-amplify-react Authenticator.
  // It has been simplified to remove unused logic, but primarily we customize the UI & global error handling.
  public render() {
    const { authState, authData, error, showToast, toast } = this.state;
    const theme = this.props.theme || AmplifyTheme;
    const messageMap = this.props.errorMessage;

    const propsChildren = [
      <SignIn key='signIn' />,
      <ConfirmSignIn key='confirmSignIn' />,
      <RequireNewPassword key='requireNewPassword' />,
      <ForgotPassword key='forgotPassword' />,
    ];

    // Manage the props on the AuthPieces.
    // This code was taken from the original aws-amplify-react.Authenticator.render()

    const renderChildren = React.Children.map(
      propsChildren,
      (child: React.ReactElement<any>, index) => {
        return React.cloneElement(child, {
          key: 'aws-amplify-authenticator-props-children-' + index,
          theme,
          messageMap,
          authState,
          authData,
          onStateChange: this.handleStateChange,
          onAuthEvent: this.handleAuthEvent,
          onToast: this.handleToast,
          hide: [],
        });
      },
    );

    return (
      <Container className='cu-sheet cu-mx-auto cu-mt-7 cu-p-3 cu-bs-3'>
        {showToast && error && (
          <Alert type='error'>{I18n.get(error, error)}</Alert>
        )}
        {showToast && toast && (
          <Toast
            type={ToastType.SUCCESS}
            title={toast.title}
            message={toast.message}
            onClose={this.onCloseToast}
          />
        )}
        <LogoContainer>
          <Logo src={vibeLogo} />
        </LogoContainer>

        <div className='cu-p-3'>{renderChildren}</div>
      </Container>
    );
  }

  protected handleToast = (toast: { title: string; message: string }) => {
    this.setState({
      toast,
      showToast: true,
      error: null,
    });
    setTimeout(this.onCloseToast, TOAST_FADE_TIME);
  };

  private onCloseToast = () => {
    this.setState({
      toast: null,
    });
  };
}

const Container = styled.div`
  width: 329px;
`;

const Logo = styled.img(
  ({ theme }) => `
  width: calc(${theme.spacings[2]} * 11.25);
  height: ${theme.spacings[5]};
  margin-left: ${theme.spacings[3]};
`,
);

const LogoContainer = styled.div(
  ({ theme }) => `
  display: block;
  margin: ${theme.spacings[4]} 0 ${theme.spacings[3]};
  `,
);

export default CuralateAuthenticator;
